




















































































































































































































import Vue, { PropType } from 'vue';
import { mapGetters, mapActions } from 'vuex';

import { cloneDeep, debounce, kebabCase, isEmpty } from 'lodash';
import { BForm, BFormInput, BCol, BRow, BFormCheckbox, BCollapse, VBTooltip } from 'bootstrap-vue';
import { ZenFormGroup } from 'zenComponents';
import ZenMultiselect from '@reciprocity/multiselect';
import EditableLabel from '@/components/editable_label/EditableLabel.vue';
import ItemStatusIndicator from '@/components/editable_label/ItemStatusIndicator.vue';
import PeopleDropdown from '@/components/presenters/PeopleDropdown.vue';
import InputWithVariables from '@/components/inputs_with_variables/InputWithVariables.vue';
import RichTextWithVariables from '@/components/inputs_with_variables/RichTextWithVariables.vue';
import WorkflowTriggerSelector from './WorkflowTriggerSelector.vue';

export interface WorkflowStepData {
  id: number;
  title: string;
  description: string;
  actionTrigger: string | null;
  triggerType: 'WORKFLOW_ACTION' | 'RISK_THRESHOLD' | null;
  riskTrigger: { id: string; label: string } | null;
  sourceType: string | null;
  assignees: number[];
  reviewers: number[];
  verifiers: number[];
  content: string;
  startDelta: number;
  endDelta: number;
  active: boolean;
}

const WORKFLOW_DATE_DELTAS = [
  { label: 'Immediately', value: 0 },
  { label: 'After 1 day', value: 1 },
  { label: 'After 2 days', value: 2 },
  { label: 'After 3 days', value: 3 },
  { label: 'After 1 week', value: 7 },
  { label: 'After 2 weeks', value: 14 },
  { label: 'After 1 month', value: 30 },
];

const WorkflowStep = Vue.extend({
  name: 'WorkflowStep',
  components: {
    BCol,
    BCollapse,
    BForm,
    BFormCheckbox,
    BFormInput,
    BRow,
    EditableLabel,
    ItemStatusIndicator,
    PeopleDropdown,
    WorkflowTriggerSelector,
    ZenFormGroup,
    ZenMultiselect,
    InputWithVariables,
    RichTextWithVariables,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    value: {
      type: Object as PropType<WorkflowStepData>,
      required: true,
      default: () => {},
    },
    users: {
      type: Array,
      required: false,
      default: () => [],
    },
    forcedCollapse: {
      type: Boolean,
      default: false,
    },
    serverError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: <string>'',
      titleTooLong: <boolean>false,
      titleMissing: <boolean>false,
      endBeforeStart: <boolean>false,
      dateDeltas: WORKFLOW_DATE_DELTAS,
      collapsedVisible: false,
    };
  },
  computed: {
    ...mapGetters(['isInstantEmailsOn', 'featureFlags']),
    tooltipTitle() {
      return `You can choose to enable or disable the '${this.step.stepTitle}' step`;
    },
    switchLabel() {
      return this.step.active ? 'Enabled' : 'Disabled';
    },
    startDeltaItem() {
      return this.dateDeltas.find(delta => delta.value === this.step.startDelta);
    },
    endDeltaItem() {
      return this.dateDeltas.find(delta => delta.value === this.step.endDelta);
    },
    stepClasses() {
      return {
        collapsed: !this.step.expanded,
        inactive: !this.step.active,
      };
    },
    validation() {
      return this.step.validationErrors;
    },
    indicatorStatus() {
      return !isEmpty(this.step.validationErrors) || this.step.serverError ? 'invalid' : this.step.dirty ? 'dirty' : '';
    },
    step() {
      return cloneDeep(this.value as WorkflowStepData);
    },
  },
  watch: {
    'step.expanded'(expanded) {
      clearTimeout(this.collapsedTimer);
      if (expanded) {
        this.collapsedVisible = true;
      } else {
        // Wait for animation to finish:
        this.collapsedTimer = setTimeout(() => {
          this.collapsedVisible = false;
        }, 350);
      }
    },
  },
  mounted() {
    this.collapsedVisible = this.step.expanded;
  },
  methods: {
    ...mapActions('workflows', ['updateStep']),
    setStepProperty(stepProperty, value) {
      this.step[stepProperty] = value;
      this.debouncedPropertyUpdate();
    },
    debouncedPropertyUpdate: debounce(function() {
      this.updateStep({ id: this.step.id, data: this.step });
    }, 500),
    toggleStep() {
      this.step.expanded = !this.step.expanded;
      this.updateStep({ id: this.step.id, data: this.step });
    },
    toggleActive() {
      this.step.active = !this.step.active;
      this.updateStep({ id: this.step.id, data: this.step });
    },
    deleteClicked() {
      this.$emit('delete-clicked', this.step.id);
    },
    updateTitle(stepTitle: string) {
      this.updateStep({ id: this.step.id, data: { stepTitle } });
    },
    removeJustCreated() {
      this.updateStep({ id: this.step.id, data: { justCreated: false, expanded: true } });
    },
    kebabCase,
  },
});
export default WorkflowStep;
